<template>
  <div class="view pa24">
    <!--    <div class="d-flex">-->
    <!--      <el-row :gutter="24">-->
    <!--        <el-col :xl="24" :lg="16" class="d-flex justify-content-between w100p">-->
    <!--          <div class="d-flex align-items-center">-->
    <!--            <el-input-->
    <!--                v-model="name"-->
    <!--                class="mb10"-->
    <!--                style="width: 240px"-->
    <!--                placeholder="请输入类别名称"-->
    <!--                clearable-->
    <!--            />-->
    <!--            <el-button class="ml10 mb10" type="primary" @click="getCustomer">搜索</el-button>-->
    <!--          </div>-->
    <!--        </el-col>-->
    <!--      </el-row>-->
    <!--    </div>-->
    <el-button class="ml10 mb10" type="primary" @click="toForm('add')">新增打印规格</el-button>
    <el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" row-key="id" border default-expand-all
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
      <el-table-column prop="name" align="center" label="规格名称" />
      <el-table-column prop="paperWidth" align="center" label="纸张宽度(mm)">
      </el-table-column>
      <el-table-column prop="paperHeight" align="center" label="纸张高度(mm)">
      </el-table-column>
      <el-table-column prop="intro" align="center" label="描述">
      </el-table-column>
      <el-table-column prop="createBy" align="center" label="操作人" />
      <el-table-column prop="createTime" align="center" label="创建时间" />
      <el-table-column align="center" width="200" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="toForm('edit',scope.row)">编辑</el-button>
          <el-button type="text" style="color: red" @click="del(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pageBox">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageNum" :page-sizes="[10, 15, 20]" layout="total, sizes, prev, pager, next, jumper" class=""
        :total="total" :pager-count="5" />
    </div>

    <el-dialog title="打印规格" :visible.sync="dialogFormVisible" append-to-body>
      <el-form ref="form" :model="form" label-width="120px" :rules="rules">
        <el-form-item label="规格名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="纸张宽度(mm)" prop="paperWidth">
          <el-input v-model="form.paperWidth"
            on-keypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))"></el-input>
        </el-form-item>
        <el-form-item label="纸张高度(mm)" prop="paperHeight">
          <el-input v-model="form.paperHeight"
            on-keypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))"></el-input>
        </el-form-item>
        <el-form-item label="规格描述" prop="intro">
          <el-input type="textarea" v-model="form.intro"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import { selectCodePrintList, addCodePrint, delCodePrint } from '@/api/storeCodePrint.js'
  export default {
    components: {

    },
    props: {

    },
    data() {
      return {
        name: null,
        tableData: [],
        pageSize: 10,
        pageNum: 1,
        total: 0,
        dialogFormVisible: false,
        formLabelWidth: 100,
        form: {
          id: '',
          paperWidth: 0,
          paperHeight: 0,
          name: '',
          intro: ''
        },
        rules: {
          name: [{ required: true, message: '规格名称不能为空' }],
          paperWidth: [{ required: true, message: '纸张宽度不能为空' }],
          paperHeight: [{ required: true, message: '纸张高度不能为空' }]
        },
      };
    },
    created() {
      this.getList()
    },
    methods: {
      getCustomer() {
        this.getList()
      },
      handleSizeChange(num) {
        this.pageSize = num;
        this.pageNum = 1;
        this.getList();
      },
      handleCurrentChange(num) {
        this.pageNum = num;
        this.getList();
      },
      getList() {
        let params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }
        selectCodePrintList(params).then(res => {
          this.tableData = res.data.list
          this.total = res.data.total
        })
      },
      toForm(type, data) {
        if ('add' == type) {
          this.dialogFormVisible = true
        } else if ('edit' == type) {
          this.form = data
          this.dialogFormVisible = true
        }
      },
      submitForm() {
        addCodePrint(this.form).then(res => {
          this.$nextTick(() => {
            this.$refs.form.resetFields()
          })
          this.$message.success("操作成功")
          this.getList()
          this.dialogFormVisible = false
        })
      },
      del(data) {
        this.$confirm('此操作将永久删除该规格, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delCodePrint({ id: data.id }).then(res => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.getList()
          })
        }).catch(() => {

        });
      }
    },
  }
</script>
<style scoped>
  .pageBox {
    display: flex;
    justify-content: flex-end;
  }
</style>